export enum PostDetailActions {
  NOT_STARTED = 'not_started',
  CREATE = 'create',
  UPDATE = 'update',
}
